import * as React from 'react';

export type AiIframeMsg = {
  type: 'search' | 'popup';
  height: number;
  session_id?: string;
  event_type?: string;
};

export const useAiMsg = (
  type: 'search' | 'popup',
  callback: (msg: AiIframeMsg) => void,
  deps: any[]
): { showIframe: boolean; setShowIframe: (show: boolean) => void; iframeHeight: number } => {
  const [showIframe, setShowIframe] = React.useState(false);
  const [iframeHeight, setIframeHeight] = React.useState(0);

  React.useEffect(() => {
    const handleMsg = (e) => {
      if (!e.data) return;
      if (e?.data?.source === 'react-devtools-bridge') return;
      if (e?.data?.source === 'react-devtools-content-script') return;
      if (e?.data?.source === 'react-devtools-backend-manager') return;
      if (e?.data?.type === 'panelhide') return;
      //console.log("handleMsg", e, e.data);
      const msg = e.data as AiIframeMsg;

      if (msg.type !== 'search' && msg.type !== 'popup') {
        //console.log('invalid message', msg);
        return;
      }

      if (msg.type !== type) {
        // console.log('invalid message type', msg);
        return;
      }

      if (typeof msg.height === 'number') {
        setIframeHeight(msg.height);
      }
      callback(msg);

      //console.log('handleMsg', msg);
      // if (e.data === 'api_success') {
      //   setShowIframe(true);
      //   console.log("iframe 작업 성공 메시지 수신");
      //   callback('api_success');
      //   setMsg('api_success');
      // } else if (e.data === 'api_fail') {
      //   console.log("iframe 작업 실패 메시지 수신");
      //   callback('api_fail');
      //   setMsg('api_fail');
      // } else if (e.data === 'close_iframe') {
      //   setShowIframe(false);
      //   console.log("iframe 작업 종료 메시지 수신");
      //   callback('close_iframe');
      //   setMsg('close_iframe');
      // }
    };

    window.addEventListener('message', handleMsg);

    return () => {
      window.removeEventListener('message', handleMsg);
    };
  }, [...(deps || [])]);

  return { showIframe, setShowIframe, iframeHeight };
};
